import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { RouterModule } from '@angular/router';
import { SeoService } from '../../seo/seo.service';

@Component({
  standalone: true,
  selector: 'app-blog-5-consigli-casa',
  imports: [CommonModule, RouterModule],
  templateUrl: './5-consigli-casa-sempre-pulita.html',
  styleUrls: ['./5-consigli-casa-sempre-pulita.scss'],
})
export class Blog5ConsigliCasaComponent implements OnInit {
  constructor(private seo: SeoService) {}

  ngOnInit(): void {
    this.seo.updateTags({
      title: '5 consigli per mantenere la casa sempre pulita | SAMI Pulizie',
      description:
        '5 consigli pratici per mantenere la casa sempre pulita e in ordine. Abitudini quotidiane e supporto professionale a Pescara.',
      keywords:
        'pulizie domestiche Pescara, casa sempre pulita, consigli pulizia casa, impresa di pulizie Pescara, SAMI Pulizie',
      canonicalUrl: '/blog/5-consigli-casa-sempre-pulita',

      ogTitle: '5 consigli per mantenere la casa sempre pulita',
      ogDescription:
        'Piccole abitudini quotidiane per mantenere la casa sempre pulita e ordinata.',
      ogImage: '/assets/logo.png',
      ogType: 'article',

      jsonLd: {
        '@context': 'https://schema.org',
        '@type': 'BlogPosting',
        headline: '5 consigli per mantenere la casa sempre pulita',
        description:
          'Consigli pratici per mantenere la casa pulita e ordinata con semplici abitudini quotidiane.',
        datePublished: '2025-03-26',
        dateModified: '2025-03-26',
        author: {
          '@type': 'Organization',
          name: 'SAMI Pulizie',
        },
        publisher: {
          '@type': 'Organization',
          name: 'SAMI Pulizie',
          logo: {
            '@type': 'ImageObject',
            url: 'https://samipulizie.it/assets/logo.png',
          },
        },
        mainEntityOfPage: {
          '@type': 'WebPage',
          '@id': 'https://samipulizie.it/blog/5-consigli-casa-sempre-pulita',
        },
      },
    });
  }
}
